import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatTime', (value, format = 'LTS') => {
  if (value) {
    return moment(String(value)).format(format)
  }
})
